module.exports = "/fonts/vendor/linearicons/dist/web-Linearicons-Free.ttf?5cbe0a85581dc42087ac6646f579502e";